import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface ServiceHeroProps {
  className?: string;
}

const ServiceHero = ({ className = '' }: ServiceHeroProps) => {
  return (
    <section className={`relative bg-gradient-to-br from-primary via-primary to-secondary py-20 md:py-28 lg:py-32 overflow-hidden ${className}`}>
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-accent rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-conversion rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center max-w-4xl mx-auto">
          {/* Badge */}
          <div className="inline-flex items-center space-x-2 bg-primary-foreground/10 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
            <Icon name="SparklesIcon" size={20} className="text-accent" />
            <span className="text-primary-foreground font-medium text-sm">
              Science-Backed Sustainability Solutions
            </span>
          </div>

          {/* Main Heading */}
          <h1 className="font-heading font-bold text-4xl md:text-5xl lg:text-6xl text-primary-foreground mb-6 leading-tight">
            Comprehensive ESG & Carbon Credit Solutions
          </h1>

          {/* Description */}
          <p className="text-lg md:text-xl text-primary-foreground/90 mb-8 leading-relaxed max-w-3xl mx-auto">
            From carbon credit generation to ESG reporting and water conservation, we provide end-to-end solutions that drive measurable environmental impact and regulatory compliance.
          </p>

          {/* Stats Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 md:gap-8 mt-12">
            <div className="bg-primary-foreground/10 backdrop-blur-sm rounded-xl p-6 border border-primary-foreground/20">
              <div className="text-3xl md:text-4xl font-heading font-bold text-accent mb-2">
                500+
              </div>
              <div className="text-primary-foreground/90 font-medium">
                Projects Completed
              </div>
            </div>
            <div className="bg-primary-foreground/10 backdrop-blur-sm rounded-xl p-6 border border-primary-foreground/20">
              <div className="text-3xl md:text-4xl font-heading font-bold text-accent mb-2">
                2.5M+
              </div>
              <div className="text-primary-foreground/90 font-medium">
                Tonnes CO₂ Sequestered
              </div>
            </div>
            <div className="bg-primary-foreground/10 backdrop-blur-sm rounded-xl p-6 border border-primary-foreground/20">
              <div className="text-3xl md:text-4xl font-heading font-bold text-accent mb-2">
                98%
              </div>
              <div className="text-primary-foreground/90 font-medium">
                Client Satisfaction
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceHero;